import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'
import { keyframes, styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ProfileItemRoundButton = styled(Button)`
  border-radius: 18px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledShortlistItemsContainer = styled('div')`
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 6px 0;
`

export const StyledShortlistItemsContainerOuter = styled('div')`
  border-top: 0.5px solid #d3d3d3;
  border-bottom: 0.5px solid #d3d3d3;
  padding: 5px 0;
  margin: 16px 0;
`

export const DeleteIconWrapper = styled(IconButton)`
  padding: 0;
  margin-left: -4px;
`

export const ShortlistItemWrapper = styled('div')`
  display: flex;
  align-items: start;
  padding: 5px 0;
`

const borderColorChange = keyframes`
  0% {
    border: 2px solid ${colors.primaryDark} ;
  }

  100% {
    border-color: transparent;
  }
`

export const ShortlistItemName = styled('div')`
  padding: 0 5px;
  white-space: break-spaces;
  min-height: 30px;
  display: flex;
  align-items: center;
  word-break: break-all;
  flex: 1 1 auto;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 4px;

  &:hover {
    border: 1px solid ${colors.darkGray};
  }

  &.border-animation {
    animation: ${borderColorChange} 5s ease-in-out;
  }
`

export const ShortlistItemTextField = styled(TextField)`
  width: 100%;

  & .MuiInputBase-root {
    min-height: 30px;
  }

  & .MuiInputBase-input {
    padding: 5px;
  }
`
